var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3667 14.0417C13.8 13.6501 14.3667 13.4001 15 13.4001C16.3417 13.4001 17.4333 14.4917 17.4333 15.8334C17.4333 17.1751 16.3417 18.2668 15 18.2668C13.6583 18.2668 12.5667 17.1751 12.5667 15.8334C12.5667 15.6501 12.5917 15.4667 12.6333 15.2917L6.7 11.8251C6.25 12.2417 5.65833 12.5001 5 12.5001C3.61667 12.5001 2.5 11.3834 2.5 10.0001C2.5 8.61675 3.61667 7.50008 5 7.50008C5.65833 7.50008 6.25 7.75842 6.7 8.17508L12.575 4.75008C12.5333 4.55841 12.5 4.36675 12.5 4.16675C12.5 2.78341 13.6167 1.66675 15 1.66675C16.3833 1.66675 17.5 2.78341 17.5 4.16675C17.5 5.55008 16.3833 6.66675 15 6.66675C14.3417 6.66675 13.75 6.40842 13.3 5.99175L7.425 9.41675C7.46667 9.60842 7.5 9.80008 7.5 10.0001C7.5 10.2001 7.46667 10.3917 7.425 10.5834L13.3667 14.0417Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.23dce0a78556ac23dad4c8e23e180d16.svg";
export { ForwardRef as ReactComponent };